import SystemLabel from "./SystemLabel";
export default SystemLabel;
